import { createFileRoute } from '@tanstack/react-router';
import SectionEditPage from '@/features/resume-builder/section-edit';

export const Route = createFileRoute('/perfil/curriculo/$section/$itemId/editar')({
  component: SectionEditPage,
});
